module.exports = __webpack_public_path__ + "img/lijunliang.500182f7.jpg";